import { Skeleton, Stack } from '@chakra-ui/react';
import { ProcessedPromo } from '@diamond/sol-buyer/utils';

import { LabelPromo } from './label-promo';

type LabelPromoListProps = {
  processedPromo: ProcessedPromo;
  isLoading?: boolean;
};
export function LabelPromoList({
  processedPromo,
  isLoading = false,
}: LabelPromoListProps) {
  const {
    hasFreeGoods,
    hasBundledFreeGoods,
    hasMultiFreeGoods,
    hasDiscount,
    hasBundledDiscount,
    hasCashback,
    hasBundledCashback,
    minOrderQty,
    qtyFreeGoods,
    isVoucherFreeGoods,
  } = processedPromo;

  if (isLoading) {
    return (
      <Stack direction="row" spacing="2">
        <Skeleton
          height="5"
          width={{ base: '12', lg: '24' }}
          borderRadius="xl"
        />
        <Skeleton
          height="5"
          width={{ base: '8', lg: '20' }}
          borderRadius="xl"
        />
      </Stack>
    );
  }

  return (
    <>
      {(hasFreeGoods || hasBundledFreeGoods) && !hasMultiFreeGoods ? (
        <LabelPromo
          type="free-item"
          minOrderQty={minOrderQty}
          qtyFreeGoods={qtyFreeGoods}
          isVoucherFreeGoods={isVoucherFreeGoods}
        />
      ) : null}
      {hasMultiFreeGoods ? (
        <LabelPromo
          type="multi-free-item"
          minOrderQty={minOrderQty}
          qtyFreeGoods={qtyFreeGoods}
        />
      ) : null}
      {hasDiscount || hasBundledDiscount ? (
        <LabelPromo type="discount" />
      ) : null}
      {hasCashback || hasBundledCashback ? (
        <LabelPromo type="cashback" />
      ) : null}
    </>
  );
}
